import React from 'react';
import { ELSIcon } from '../index';
var Breadcrumb = function (props) {
    var separator = <ELSIcon name="chevron-right" size="1x" customClass="u-els-color-n4" align="middle"/>;
    var children = React.Children.toArray(props.children);
    var lastIdx = children.length - 1;
    return (<div className="c-breadcrumb u-els-display-flex o-els-flex-layout--wrap">
      {children.map(function (child, idx) { return (
        // eslint-disable-next-line react/no-array-index-key
        <div key={"breadcrumb_item_".concat(idx)}>
          <span className="c-breadcrumb-item">{child}</span>
          {idx !== lastIdx && <span className="u-els-margin-1o2 c-breadcrumb-separator">{separator}</span>}
        </div>); })}
    </div>);
};
export default Breadcrumb;
